module.exports = __webpack_public_path__ + "vue/img/ewm.dd00e2e2.jpg";